import React from 'react';

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cocoa-400 focus-visible:ring-offset-2 ' +
  'disabled:pointer-events-none disabled:opacity-50';

const VARIANTS = {
  primary: 'bg-cocoa-800 text-cream-50 hover:bg-cocoa-900',
  secondary: 'border border-cocoa-300 bg-transparent text-cocoa-800 hover:bg-cocoa-50',
  ghost: 'bg-transparent text-cocoa-700 hover:bg-cocoa-100',
  danger: 'bg-clay-600 text-white hover:bg-clay-700',
  caramel: 'bg-caramel-500 text-white hover:bg-caramel-600',
};

const SIZES = {
  sm: 'min-h-[36px] px-4 text-xs',
  md: 'min-h-[44px] px-5 text-sm',
  lg: 'min-h-[48px] px-6 text-base',
};

const Spinner = () => (
  <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4zm2 5.2A8 8 0 014 12H0c0 3 1.1 5.8 3 7.9l3-2.6z"
    />
  </svg>
);

const Button = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  className = '',
  children,
  disabled,
  type = 'button',
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    className={`${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    {...rest}
  >
    {loading && <Spinner />}
    {children}
  </button>
);

export default Button;
